import { WidgetsSetup } from 'components/posts/detail/layout/widgetsSetup/WidgetsSetupProvider';
import { DropResult } from 'react-beautiful-dnd';
import ArrayUtils from 'app/utils/array';

export type DropResultDestination = Omit<DropResult, 'destination'> & {
  destination: { droppableId: 'expanded' | 'collapsed'; index: number };
};

export function segmentWidgets(value: WidgetsSetup[]) {
  return {
    expanded: value.filter(({ isExpanded }) => isExpanded),
    collapsed: value.filter(({ isExpanded }) => !isExpanded),
  };
}

function hasDropDestination(
  result: DropResult,
): result is DropResultDestination {
  return !!result.destination;
}

function moveItemBetweenLists({
  expanded,
  collapsed,
  result,
}: {
  expanded: WidgetsSetup[];
  collapsed: WidgetsSetup[];
  result: DropResultDestination;
}) {
  if (result.destination.droppableId === 'expanded') {
    const itemToMove = { ...collapsed[result.source.index], isExpanded: true };

    expanded.splice(result.destination.index, 0, itemToMove);
    collapsed.splice(result.source.index, 1);
  } else {
    const itemToMove = { ...expanded[result.source.index], isExpanded: false };

    collapsed.splice(result.destination.index, 0, itemToMove);
    expanded.splice(result.source.index, 1);
  }
  return { expanded, collapsed };
}

export function organizeWidgetsSetup(
  widgets: WidgetsSetup[],
  result: DropResult,
) {
  if (!hasDropDestination(result)) {
    return widgets;
  }

  let { expanded, collapsed } = segmentWidgets(widgets);

  const isDroppableSame =
    result.destination.droppableId === result.source.droppableId;

  if (isDroppableSame) {
    const isMovingToExpanded = result.destination.droppableId === 'expanded';

    const listToUpdate = isMovingToExpanded ? expanded : collapsed;

    const updatedList = ArrayUtils.move(
      listToUpdate,
      result.source.index,
      result.destination.index,
    );

    if (isMovingToExpanded) {
      expanded = updatedList;
    } else {
      collapsed = updatedList;
    }
  } else {
    const updateResult = moveItemBetweenLists({
      expanded,
      collapsed,
      result,
    });

    expanded = updateResult.expanded;
    collapsed = updateResult.collapsed;
  }

  return [...expanded, ...collapsed];
}
